<template>
  <footer class="flex align-center py-2 question-footer justify-content mt-3">

    <section class="question-footer__left flex align-center justify-start px-1" />

    <section class="question-footer__right flex align-center justify-end px-1">
      <button
        v-if="showDelete"
        role="button"
        class="question-footer__button question-footer__button--iconed
        inline-flex rounded-circle align-center cursor-pointer mx-1 p-1-2"
        @click.prevent.stop="$emit('delete')">
        <SmartIcon
          class="p-1-2"
          name="trash"
          :size="3"
        />
      </button>
      <button
        v-if="showCopy"
        role="button"
        class="question-footer__button question-footer__button--iconed
        inline-flex rounded-circle align-center cursor-pointer mx-1 p-1-2"
        @click.prevent.stop="$emit('copy')">
        <SmartIcon
          class="p-1-2"
          name="copy"
          :size="3"
        />
      </button>
      <div
        aria-hidden="true"
        class="question-footer__line h-5"
      />
      <button
        v-if="showNewQuestion"
        role="button"
        class="question-footer__button inline-flex rounded
        align-center text-brand-secondary px-2 py-1 mx-1 cursor-pointer"
        @click.prevent.stop="$emit('newQuestion')">
        <SmartIcon
          class="mr-1"
          name="plus"
          :size="2"
        />
        {{ labels.newQuestion }}
      </button>
    </section>

  </footer>
</template>

<script>
export default {
  components: {
    SmartIcon: () => import('packages/SmartIcon')
  },
  props: {
    showDelete: {
      type: Boolean,
      default: true
    },
    showCopy: {
      type: Boolean,
      default: true
    },
    showNewQuestion: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    labels: {
      newQuestion: 'Nova Pergunta'
    }
  })
};
</script>

<style lang="scss">
$border-question-default: 1px solid rgba($color-ui-black, $opacity-low-half);

.question-footer {
  border-top: $border-question-default;
  &__left {
    [role="checkbox"] {
      border-right: $border-question-default;
    }
  }
  &__button {
    border: none;
    transition-property: background-color, opacity, box-shadow;
    transition-duration: $transition-sm-slow;
    transition-timing-function: $transition-easing-default;
    &:focus {
      outline: none;
    }
    &:not(:disabled) {
      &:hover {
        opacity: $font-opacity-hg;
        background-color: rgba($color-brand-secondary, $opacity-low-min);
      }
      &:focus, &:active {
        opacity: 1;
        background-color: rgba($color-brand-secondary, $opacity-low-half);
        box-shadow: 0 0 0 3px rgba($color-brand-secondary, $opacity-low-min);
      }
    }
    &:disabled {
      cursor: not-allowed;
      * {
        cursor: not-allowed;
      }
    }
    &--iconed {
      &:not(:disabled) {
        &:hover {
          background-color: rgba($color-ui-black, $opacity-low-min);
        }
        &:focus, &:active {
          background-color: rgba($color-ui-black, $opacity-low-half);
          box-shadow: 0 0 0 3px rgba($color-ui-black, $opacity-low-min);
        }
      }
    }
  }
  &__line {
    width: 1px;
    background: rgba($color-ui-black, $opacity-low-half);
  }
}
</style>
